import * as angular from "angular";

export class CancellationReasonsRequestsService {

  /* @ngInject */
  constructor(private CancellationReasonsAPI, private $cancellationReasons) {
  }

  createCancellationReason(cancellationReason) {
    const api = this.CancellationReasonsAPI.actions.createCancellationReason;
    return this.$$call(api, {}, cancellationReason, {});
  }

  updateCancellationReason(updatedCancellationReason) {
    const api = this.CancellationReasonsAPI.actions.updateCancellationReason;
    return this.$$call(api, {}, updatedCancellationReason, {id: updatedCancellationReason.id});
  }

  deleteCancellationReason(cancellationReasonId) {
    const api = this.CancellationReasonsAPI.actions.deleteCancellationReason;
    return this.$$call(api, {}, {}, {id: cancellationReasonId});
  }

  // ******************************
  //        Private methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$cancellationReasons().$call(_apiCall, _params, _data, _options);
  }
}
angular
  .module('bringoz.admin.cancellation-reasons')
  .service('cancellationReasonsRequestsService', CancellationReasonsRequestsService);
